// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__nK-dN","select":"Header_select__3W1-X","clinic":"Header_clinic__3J8MR"};